/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import type { FC } from 'react';

import { useDispatch } from 'react-redux';

import { icons } from '@assets/index';
import { ImgStyled } from '@components/common/Block/Img';
import { modalOpen } from '@modules/modal/modalActions';

import { TReportId } from '../../types';
import { TableScheduleCellRemoveStyled } from '../styled/TableScheduleStyled';
import { ScheduleRemoveModal } from './ScheduleRemoveModal';

interface IProps {
    cppoId: number;
    reportId: TReportId;
};

export const TableScheduleCellRemove: FC<IProps> = ({ cppoId, reportId }) => {
    const dispatch = useDispatch();

    const handleRemoveSchedule = () => {
        dispatch(modalOpen({
            modalParams: {
                isCustomCrossButton: true,
            },
            render: ({ onCloseModal }) =>
                <ScheduleRemoveModal
                    cppoId={cppoId}
                    reportId={reportId}
                    onCloseModal={onCloseModal}
                />,
        }));
    };

    return (
        <TableScheduleCellRemoveStyled onClick={handleRemoveSchedule}>
            <ImgStyled height='20px' src={icons.deleteIcon} width='16px' />
        </TableScheduleCellRemoveStyled>
    );
};
